<ca-modal-container class="p-0" (dismiss)="close()">
    <ca-module-detail
        class="module-detail"
        [moduleId]="moduleId"
        [isModuleInReview]="isModuleInReview"
        [isReadOnly]="true"
        (onHasFinishedLoading)="handleFinishedLoading()"
    >
    </ca-module-detail>
</ca-modal-container>
